import AppConstants from '../config/app.constants';

let HomeService = function ($http, $q) {

    let dashboard = (date, branch, loggedInUserId) => {
        return $http
            .get(AppConstants.api + `/home/home-screen-details`, {
                params: {
                    date,
                    branch,
                    loggedInUserId
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let configs = () => {
        return $http
            .get(AppConstants.api + `/home/configs`, {})
            .then((res) => {
                return res.data
            })
    }

    let getBranchLiability = (branchId) => {
        return $http
            .get(AppConstants.api + `/home/get-branch-liability`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let updateVaultLiability = (branchId, vaultLiability) => {
        return $http
            .post(AppConstants.api + `/home/update-vault-liability`, {
                branchId,
                vaultLiability
            })
            .then((res) => {
                return res.data;
            })
    };

    let branchStats = (branchId, startDate, endDate, loggedInUserId) => {
        return $http
            .get(AppConstants.api + `/home/branch-stats`, {
                params: { branchId, startDate, endDate, loggedInUserId }
            })
            .then((res) => {
                return res.data;
            })
    };

    return {
        dashboard,
        configs,
        getBranchLiability,
        updateVaultLiability,
        branchStats
    };
};

HomeService.$inject = ['$http', '$q']

export default HomeService;


// WEBPACK FOOTER //
// ./client/app/services/home.service.js